import { CurrentUserStore } from '../../../../User/CurrentUserStore';
import { TranslatingFeature } from '../../../../Role/Model/Features';

export function hasAccessToTranslationCenter(
    currentUserStore: CurrentUserStore
): boolean
{
   return currentUserStore.isSupport
        || currentUserStore.rightProfile.role.isPermissionGrantedForFeature(TranslatingFeature);
}